module.exports = __webpack_public_path__ + "static/img/qbye@2x.c1bc9d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qbye@2x.png
// module id = RiaH
// module chunks = 0